import { CellGroup, Cell } from 'vant'
import Bussiness from 'Utils/business'
import { mapState } from 'vuex'
import { formatDate } from 'Utils/dateUtil'
import {isGat, toPayForGat} from "Utils/gattools";

export default {
  name:'HtOrderComplete',
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    // ldPay: () => import('Components/ldPay/index.vue'),
    ldButton: () => import('Common/ldButton'),
    ldTabbar: () => import('Components/ldTabbar/ldTabbar'),
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
  },
  data() {
    return {
      mescroll: null, // mescroll实例对象
      data_: {},
      model_: {
        orderType: '',
        orderId: ''
      },
      priceList: [],
      mescrollDown: {
        callback: this.loadData,
      }
    }
  },
  computed: mapState({
    /**
     * 酒店详情数据模型
     */
    data: (state) => state.ht.orderDetails
  }),
  mounted() {
    /**
     * 初始化数据
     */
    this.loadData()
  },
  created() { },
  methods: {
    mescrollInit (mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    loadData() {
      this.model_ = {
        orderType: $dict.ORDER_TYPE.hotel.normal,
        orderId: this.$route.query.orderId
      }
      this.$api['htQuery/hotelOrderDetail']({
        orderId: this.$route.query.orderId
      }).then(res => {
        this.data_ = res.data
        this.data_._rzrqweek = formatDate(this.data_.rzrq).week
        this.data_._ldrqweek = formatDate(this.data_.ldrq).week
        /**
         * 构建明细面板
         */
        this.structureDetailed()
        this.$nextTick(() => { // 数据渲染成功后,隐藏下拉刷新的状态
          this.mescroll.endSuccess()
        })
      }).catch(() => {})
    },
    /**
     * 送审
     */
    approval() {
      this.data_.orderType = '11007'
      Bussiness.ApprovalSend(this.data_)
    },
    async revertApproval() {
      this.data_.orderType = '11007'
      await Bussiness.ApprovalRevert(this.data_)
      this.loadData()
    },
    //支付
    pay(){
      // 关爱通渠道
      if (isGat()) {
        return toPayForGat(this.model_.orderId, this.model_.orderType);
      }
      this.$router.push({path:'/pay/payment',query:{orderType:this.model_.orderType,orderId:this.model_.orderId}})
    },
    payment() {

    },
    structureDetailed() {
      /**
       * 初始化 this.priceList
       */
      this.priceList = []
      /**
       * 到店付 && 需要担保的 需要在明细面板中展示[在线担保金额]
       */
      if (this.data._ratePlans && this.data._ratePlans.payment == '1' && this.data._guarantee && this.data._guarantee.isVouch == '1') {
        this.priceList.push({
          name: '在线担保',
          price: this.data._guarantee.amount,
          amount: this.data_.rooms,
          unit: this.$t('E205','间')
        })
      }
      /**
       * priceAfterTax 供应商税后价格（成本价）没值
       */
      this.data_.roomList[0].everyPriceList.forEach(element => {
        this.priceList.push({
          name: element.day,
          price: element.xsj,
          amount: this.data_.rooms,
          unit: this.$t('E205','间')
        })
      })
      this.priceList.push({
        name: this.$t('E001','服务费'),
        price: this.data._matchQueryData && this.data._matchQueryData.chargeType == '1' ? (this.data_.fwf / Number(this.data_.rooms)) : this.data_.fwf,
        amount: this.data._matchQueryData && this.data._matchQueryData.chargeType == '1' ? this.data_.rooms : '',
        unit: this.data._matchQueryData && this.data._matchQueryData.chargeType == '1' ? '间' : ''
      })
    }
  },
  watch: {}
}
